function vendors(state) {
	return state.vendors;
}

export default { vendors };